<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <ReturnTurnoverOne :data-set="dataSet" @get-claim="getClaim" @get-history-list="getHistoryList"
            @get-next-page-reward-data="getNextPageRewardData" @reset-history-data="resetHistoryData"
            @scroll-left="scrollLeft" @scroll-right="scrollRight" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <ReturnTurnoverTwo :data-set="dataSet" @get-claim="getClaim" @get-history-list="getHistoryList"
            @get-next-page-reward-data="getNextPageRewardData" @reset-history-data="resetHistoryData"
            @scroll-left="scrollLeft" @scroll-right="scrollRight" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <ReturnTurnoverThree :data-set="dataSet" @get-claim="getClaim" @get-history-list="getHistoryList"
            @get-next-page-reward-data="getNextPageRewardData" @reset-history-data="resetHistoryData"
            @scroll-left="scrollLeft" @scroll-right="scrollRight" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <ReturnTurnoverFour :data-set="dataSet" @get-claim="getClaim" @get-history-list="getHistoryList"
            @get-next-page-reward-data="getNextPageRewardData" @reset-history-data="resetHistoryData"
            @scroll-left="scrollLeft" @scroll-right="scrollRight" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { getActivityInformations } from '@/api/common';
import { ref, onMounted, computed, nextTick } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getDailyBetRewards, getDailyBetRewardsClaim, getRemainBet } from '@/api/activity';
import { generate30DaysArray, getTodayData, sumAmounts } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import ReturnTurnoverOne from '@/themes/themeOne/returnTurnover/returnTurnover.vue';
import ReturnTurnoverTwo from '@/themes/themeTwo/returnTurnover/returnTurnover.vue';
import ReturnTurnoverThree from '@/themes/themeThree/returnTurnover/returnTurnover.vue';
import ReturnTurnoverFour from '@/themes/themeFour/returnTurnover/returnTurnover.vue';
import { DailyRewardData, FutureRewards, PAGE_SIZE, ReturnTurnoverConfig, ReturnTurnOverData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const userStore = useUserStore()
const histryPopupRef = ref()
const isSuccess = ref(false);
const statusRef = ref();
const toastContent = ref('');
const loadingRef = ref();

const active = ref(0);
const showLeft = ref(false);
const showRight = ref(false);
const tabsRef = ref<any>(null);
const dayCountVal = ref(0)
const isReturnTurnover = ref(true);
const returnTurnoverConfig = ref<ReturnTurnoverConfig | null>(null);
const activityDescription = ref<string[]>([]);
const dailyRewardList = ref<DailyRewardData[]>([])
const weeklyRewardList = ref<DailyRewardData[]>([])
const historyList = ref<DailyRewardData[]>([])
const cashbackTotal = ref(0)
const availableGiftAmount = ref(0)
const claimGiftAmount = ref(0)
const futureRewards = ref<FutureRewards[]>([])
const isHaveTodayDayRewards = ref(false)
const isHaveTodayRewards = ref(false)
const todayDayRewards = ref<any>({})
const todayRewards = ref<any>({})
const todayBetDetails = ref<DailyRewardData>({
    createTime: "",
    dayCount: 0,
    status: 0,
    d2: 0,
    d3: 0,
    d4: 0,
    d5: 0,
    d6: 0,
    d7: 0,
    remainGiftAmount: 0,
    claimGiftAmount: 0,
    coin: 0,
    rewards: [],
})
const total = ref()
const pageNum = ref(1)
const pageSize = ref(PAGE_SIZE)
const bannerIcon = ref('')
const dataSet = computed<ReturnTurnOverData>(() => ({
    active: active.value,
    showLeft: showLeft.value,
    showRight: showRight.value,
    tabsRef: tabsRef.value,
    dayCountVal: dayCountVal.value,
    isReturnTurnover: isReturnTurnover.value,
    returnTurnoverConfig: returnTurnoverConfig.value,
    activityDescription: activityDescription.value,
    dailyRewardList: dailyRewardList.value,
    weeklyRewardList: weeklyRewardList.value,
    historyList: historyList.value,
    cashbackTotal: cashbackTotal.value,
    availableGiftAmount: availableGiftAmount.value,
    claimGiftAmount: claimGiftAmount.value,
    futureRewards: futureRewards.value,
    isHaveTodayDayRewards: isHaveTodayDayRewards.value,
    isHaveTodayRewards: isHaveTodayRewards.value,
    todayDayRewards: todayDayRewards.value,
    todayRewards: todayRewards.value,
    todayBetDetails: todayBetDetails.value,
    total: total.value,
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    bannerIcon: bannerIcon.value,
}))

const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "return_turnover"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        if (res.data) {
            bannerIcon.value = res.data?.floatIcon
            returnTurnoverConfig.value = res.data.config;
            activityDescription.value = JSON.parse(res.data.activityIntro);
            const activeTab = returnTurnoverConfig.value?.config?.findIndex(
                (item: any) => item.amount === res.data.config.turnoverLevel) ?? -1;
            active.value = activeTab != -1 ? activeTab : 0;
            if (weeklyRewardList.value.length <= 0) {
                dayCountVal.value = returnTurnoverConfig.value?.config[0]?.days?.length ?? 0;
            }
            updateActiveStatus(res.data.config.config);
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const checkScroll = () => {
    nextTick(() => {
        const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
        if (!scrollEl) return;
        const { scrollWidth, clientWidth, scrollLeft } = scrollEl;
        showLeft.value = scrollLeft > 0;
        showRight.value = scrollLeft + clientWidth < scrollWidth;
    });
};

const scrollLeft = () => {
    const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
    if (scrollEl) {
        scrollEl.scrollBy({ left: -150, behavior: 'smooth' });
        setTimeout(checkScroll, 300);
    }
};

const scrollRight = () => {
    const scrollEl = tabsRef.value?.$el?.querySelector('.van-tabs__nav');
    if (scrollEl) {
        scrollEl.scrollBy({ left: 150, behavior: 'smooth' });
        setTimeout(checkScroll, 300);
    }
};

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
// Update the active status of days based on the first active day
const updateActiveStatus = (data: any) => {
    let activeDay = null;

    for (let obj of data) {
        for (let dayEntry of obj.days) {
            if (dayEntry.activeStatus === 1) {
                activeDay = dayEntry.day;
                break;
            }
        }
        if (activeDay !== null) break;
    }

    if (activeDay === null) {
        isReturnTurnover.value = false;
        return data;
    }

    for (let obj of data) {
        for (let dayEntry of obj.days) {
            if (dayEntry.day > activeDay) {
                dayEntry.activeStatus = 11;
            }
        }
    }

    return data;
}

const getNextPageRewardData = () => {
    if (total.value > pageSize.value * pageNum.value) {
        loadingRef.value.open()
        pageNum.value = pageNum.value + 1
        getHistoryList()
    }

}

const getDailyBetRewardsData = () => {
    let data = {
        pageNum: pageNum.value,
        pageSize: 7,
    }
    getDailyBetRewards(data).then((res: any) => {
        loadingRef.value.close();
        weeklyRewardList.value = res.data.pageData.rows
        if (isHaveTodayRewards.value) {
            todayBetDetails.value.rewards = todayRewards.value
        } else {
            todayBetDetails.value = weeklyRewardList.value ? getTodayData(weeklyRewardList.value) : {}
            availableGiftAmount.value = todayBetDetails.value?.remainGiftAmount || 0
            claimGiftAmount.value = todayBetDetails.value?.claimGiftAmount || 0
        }
        // futureRewards.value = todayBetDetails.value ? todayBetDetails.value?.rewards : getDefaultRewards(dayCountVal.value)
        futureRewards.value = generate30DaysArray(todayBetDetails.value ? todayBetDetails.value?.rewards : [])

        if (!todayBetDetails.value) {
            const today = new Date().toISOString().split('T')[0];
            let defaultData = {
                createTime: today + ' 00:00:00',
                dayCount: 0,
                status: 0,
                d2: 0,
                d3: 0,
                d4: 0,
                d5: 0,
                d6: 0,
                d7: 0,
                remainGiftAmount: 0,
                claimGiftAmount: 0,
                coin: 0,
                rewards: [],
            }
            todayBetDetails.value = defaultData
            // futureRewards.value = getDefaultRewards(dayCountVal.value == 0 ? 6 : dayCountVal.value)
            futureRewards.value = generate30DaysArray(todayBetDetails.value ? todayBetDetails.value?.rewards : [])

        }
        cashbackTotal.value = sumAmounts(futureRewards.value)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const getClaim = () => {
    loadingRef.value.open();
    let data = {
        uid: userStore.id
    }
    getDailyBetRewardsClaim(data).then((res: any) => {
        loadingRef.value.close();
        showSuccess(res.msg)
        loadingRef.value.open();
        dailyRewardList.value = []
        // getDailyBetRewardsData()
        getRemainingGiftAmount()
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const getHistoryList = () => {
    loadingRef.value.open();
    let data = {
        pageNum: pageNum.value,
        pageSize: pageSize.value,
    }
    getDailyBetRewards(data).then((res: any) => {
        historyList.value = [...historyList.value, ...res.data.pageData.rows]
        total.value = res.data.pageData.total
        loadingRef.value.close();
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    total.value = 0
    pageNum.value = 1
    historyList.value = []
}

const getRemainingGiftAmount = () => {
    loadingRef.value.open();
    getRemainBet().then((res: any) => {
        loadingRef.value.close();

        let rewards = res.data.rewards || []
        todayRewards.value = rewards
        let dayRewards = res.data.dayRewards || []
        todayDayRewards.value = dayRewards

        if (rewards.length > 0) {
            isHaveTodayRewards.value = true
            availableGiftAmount.value = res.data.remainRewardAmount
            claimGiftAmount.value = res.data.claimRewardAmount
            getDailyBetRewardsData();

        } else {
            isHaveTodayRewards.value = false
            getDailyBetRewardsData();
        }

        if (dayRewards.length > 0) {
            isHaveTodayDayRewards.value = true
            todayDayRewards.value.rewards = dayRewards
            todayDayRewards.value.date = dayRewards[0].date
            todayDayRewards.value.totalAmount = res.data.totalBetAmount
        } else {
            isHaveTodayDayRewards.value = false
        }

    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
            getDailyBetRewardsData();
        }
    })
}
onMounted(() => {
    // getDailyBetRewardsData();
    getRemainingGiftAmount();
    checkScroll();
    window.addEventListener('resize', checkScroll);
    getActivityInfo();

})

</script>